<template>
  <v-app app>
    <header-tag></header-tag>
    <v-main>
      <router-view />
    </v-main>
    <footer-tag></footer-tag>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import Header from './components/parts/header.vue'
import Footer from './components/parts/footer.vue'
// ファビコンをコンパイル時に動的に変更するための特殊処理
require(`../public/favicon/${process.env.ProjectCode}/favicon.ico`)
export default {
  name: 'App',
  components: { 'header-tag': Header, 'footer-tag': Footer },
  data: function() {
    return {
      title: ''
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'getSession', 'setLoginError'])
  }
}
</script>

<style>
.theme--dark.v-btn.v-btn--has-bg{
  background-color: transparent !important;
  box-shadow: none;
}
div.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
div.v-data-table thead th {
  background-color: rgba(0, 0, 0, 0.25);
}
div.v-data-table th + th {
  border-left: 1px solid #dddddd;
}
div.v-data-table td + td {
  border-left: 1px solid #dddddd;
}
div.v-data-table table tbody tr {
  transition: background .3s cubic-bezier(.25,.8,.5,1);
  transition-property: background;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.5, 1);
  transition-delay: 0s;
  will-change: background;
}
.vue-daterange-picker {
  font-size: 14px;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
a {
  text-decoration: none;
}
.v-table {
  font-size: 0.75rem;
}
.caption {
    font-size: .75rem !important;
    letter-spacing: .0333333333em !important;
    line-height: 1.25rem;
}
.dp__menu {
  --dp-font-size: 12px !important;
}

.dp__input {
  --dp-font-size: 14px !important;
}

.dp__calendar_item {
  flex-grow: 0 !important;
}
.dp__calendar_header_item {
  --dp-cell-size: 32px !important;
  flex-grow: 0 !important;
  --dp-font-size: 12px !important;
}
.dp__cell_inner {
  --dp-cell-size: 32px !important;
}
.dp__sidebar ul {
  list-style: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.dp__sidebar li {
  padding: 5px 10px !important;
  cursor: pointer !important;
  background-color: transparent !important;
}

.dp__sidebar li:hover {
  background-color: #d4d4d4 !important;
}
.v-row > .v-col {
  padding: 4px;
}
@media screen and (max-width: 1060px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5 !important;
    height: auto !important;
    padding: 10px !important;
  }

  .mobile table li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent !important;
  }

  .mobile .flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .mobile .flex-item {
    padding: 5px;
    width: 100%;
    min-height: 40px;
    font-weight: bold;
  }

  .mobile .flex-item2 {
    padding: 5px;
    width: 50%;
    min-height: 40px;
    font-weight: bold;
  }
  .mobile .flex-item3 {
    padding: 5px;
    width: 40%;
    min-height: 40px;
    font-weight: bold;
  }
  .mobile .flex-item4 {
    padding: 5px;
    width: 60%;
    min-height: 40px;
    font-weight: bold;
  }

  .mobile .word-break {
    word-break: break-all;
  }
  .mobile a {
    color: black;
  }
}

.daterangepicker {
  top: 40px;
}

.link {
  color: #1976d2;
  cursor: pointer;
}
</style>
